module.exports = __webpack_public_path__ + "static/media/sec_zambia.c4a5ad07.jpg";